import { Component } from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {Router} from "@angular/router";
import {APP_ROUTES} from "@app/constants";

@Component({
  selector: 'app-page-not-found',

    imports: [
        ButtonDirective
    ],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.css'
})
export class PageNotFoundComponent {
  constructor(private router: Router) {

  }
  goBack() {
    this.router.navigate([APP_ROUTES.DASHBOARD]).then();
  }
}
